const DEVELOPMENT_ENV = {
	SENTRY_ENVIRONMENT: 'development',
	LOGGER_ENVIRONMENT: 'development',
	FIREBASE_API_KEY: 'AIzaSyCqVKMo5lwSQUHZFuDeRgIjfu3TF4THhBA',
	FIREBASE_AUTH_DOMAIN: 'p18738aba.firebaseapp.com',
	FIREBASE_PROJECT_ID: 'p18738aba',
	FIREBASE_STORAGE_BUCKET: 'p18738aba.appspot.com',
	FIREBASE_MESSAGING_SENDER_ID: '806130874300',
	FIREBASE_APP_ID: '1:806130874300:web:34b0ed27253d9643b51db9',
	FIREBASE_TENANT_ID: 'wally-patients-5tqvf',
	JOIN_URL: 'https://app.carebywally-stage.com/join',
	AUTH_API_URL_BASE: 'https://api.hiwally-stage.co/kauth',
	INTEL_API_URL_BASE: 'https://api.hiwally-stage.co/kintel',
	PATIENT_API_URL_BASE: 'https://api.hiwally-stage.co/kpatient',
	PROVIDER_API_URL_BASE: 'https://api.hiwally-stage.co/kprovider',
	MARKETING_API_URL_BASE: 'https://api.hiwally-stage.co/kmarketing',
	STRIPE_PUBLISHABLE_KEY: 'pk_test_pAz3jyToKdo8JXzUJdtMrsR8000DeLpmsv',
	HEAP_ID_PREFIX: 'wally-dev',
}

const STAGING_ENV = {
	SENTRY_ENVIRONMENT: 'staging',
	LOGGER_ENVIRONMENT: 'staging',
	FIREBASE_API_KEY: 'AIzaSyCqVKMo5lwSQUHZFuDeRgIjfu3TF4THhBA',
	FIREBASE_AUTH_DOMAIN: 'p18738aba.firebaseapp.com',
	FIREBASE_PROJECT_ID: 'p18738aba',
	FIREBASE_STORAGE_BUCKET: 'p18738aba.appspot.com',
	FIREBASE_MESSAGING_SENDER_ID: '806130874300',
	FIREBASE_APP_ID: '1:806130874300:web:34b0ed27253d9643b51db9',
	FIREBASE_TENANT_ID: 'wally-patients-5tqvf',
	JOIN_URL: 'https://app.carebywally-stage.com/join',
	MOBILE_DOMAIN_URL: 'http://my.carebywally-stage.com',
	AUTH_API_URL_BASE: 'https://api.hiwally-stage.co/kauth',
	INTEL_API_URL_BASE: 'https://api.hiwally-stage.co/kintel',
	PATIENT_API_URL_BASE: 'https://api.hiwally-stage.co/kpatient',
	PROVIDER_API_URL_BASE: 'https://api.hiwally-stage.co/kprovider',
	MARKETING_API_URL_BASE: 'https://api.hiwally-stage.co/kmarketing',
	STRIPE_PUBLISHABLE_KEY: 'pk_test_pAz3jyToKdo8JXzUJdtMrsR8000DeLpmsv',
	HEAP_ID_PREFIX: 'wally-sandbox',
}

const PRODUCTION_ENV = {
	SENTRY_ENVIRONMENT: 'production',
	LOGGER_ENVIRONMENT: 'production',
	FIREBASE_API_KEY: 'AIzaSyBnpK5mPteIqmgKlAE5i9ZBkv3zIpHDUU4',
	FIREBASE_AUTH_DOMAIN: 'pf47ee177.firebaseapp.com',
	FIREBASE_PROJECT_ID: 'pf47ee177',
	FIREBASE_STORAGE_BUCKET: 'pf47ee177.appspot.com',
	FIREBASE_MESSAGING_SENDER_ID: '813979563599',
	FIREBASE_APP_ID: '1:813979563599:web:12779038256f7e44b35c3a',
	FIREBASE_TENANT_ID: 'wally-patients-w541u',
	JOIN_URL: 'https://app.carebywally.com/join',
	AUTH_API_URL_BASE: 'https://api.hiwally.co/kauth',
	INTEL_API_URL_BASE: 'https://api.hiwally.co/kintel',
	PATIENT_API_URL_BASE: 'https://api.hiwally.co/kpatient',
	PROVIDER_API_URL_BASE: 'https://api.hiwally.co/kprovider',
	MARKETING_API_URL_BASE: 'https://api.hiwally.co/kmarketing',
	STRIPE_PUBLISHABLE_KEY: 'pk_live_PBIJSYpNrW1q3bOSntVx8mzs00dsdfB7fX',
	HEAP_ID_PREFIX: 'wally',
}

const ENV_MAP = {
	DEV: DEVELOPMENT_ENV,
	STAGING: STAGING_ENV,
	PROD: PRODUCTION_ENV,
}

module.exports = {
	ENV_MAP,
}
